<!-- student-details-dialog.component.html -->
<div mat-dialog-title>
  <h1>{{ data.columnName }} - Students ({{ data.students.length }})</h1>
  <button mat-button mat-dialog-close>
    <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <div class="table-container">
    <table mat-table [dataSource]="data.students" class="mat-elevation-z2">

      <!-- Student Name Column -->
      <ng-container matColumnDef="student_name">
        <th mat-header-cell *matHeaderCellDef>Student Name</th>
        <td mat-cell *matCellDef="let student">{{ student.student_name || 'Unknown' }}</td>
      </ng-container>

      <!-- Enrollment ID Column -->
      <ng-container matColumnDef="enrollment_id">
        <th mat-header-cell *matHeaderCellDef>Enrollment ID</th>
        <td mat-cell *matCellDef="let student">{{ student.enrollment_id || 'N/A' }}</td>
      </ng-container>

      <!-- Sale Date Column -->
      <ng-container matColumnDef="sale_date">
        <th mat-header-cell *matHeaderCellDef>Sale Date</th>
        <td mat-cell *matCellDef="let student">{{ formatDate(student.sale_date) }}</td>
      </ng-container>

      <!-- Finished Column: the last charged lesson that completed the enrollment -->
      <ng-container matColumnDef="completed_date">
        <th mat-header-cell *matHeaderCellDef>Finished</th>
        <td mat-cell *matCellDef="let student">{{ formatDate(student.completed_date) }}</td>
      </ng-container>

      <!-- Instructor Credits Column -->
      <ng-container matColumnDef="instructor_credits">
        <th mat-header-cell *matHeaderCellDef>Instructor Credits</th>
        <td mat-cell *matCellDef="let student">
          <div *ngIf="student.instructor_credits && student.instructor_credits.length > 0">
            <div *ngFor="let credit of student.instructor_credits" class="credit-line">
              {{ credit.instructor_name }} ({{ credit.percentage }}%) - {{ credit.amount | studioCurrency }}
            </div>
          </div>
          <span *ngIf="!student.instructor_credits || student.instructor_credits.length === 0">-</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let student">
          <button mat-icon-button
                  *ngIf="student.enrollment_id"
                  (click)="viewEnrollment(student.enrollment_id)"
                  matTooltip="View Enrollment">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</div>

